module.exports = __webpack_public_path__ + "static/img/lqqs.aefbbd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lqqs.jpg
// module id = GOX9
// module chunks = 1